<div class="w-6 h-6 bg-gray-950 dark:bg-white relative">
  <span class="strip s1 bg-white dark:bg-gray-950" [class.animate-line]="animated"></span>
  <span class="strip s2 bg-white dark:bg-gray-950" [class.animate-line-delayed-1]="animated"></span>
  <span class="strip s3 bg-white dark:bg-gray-950" [class.animate-line-delayed-2]="animated"></span>
</div>
